import React from "react";
import { StyleSheet, View } from "react-native";
import { Navigator } from "./src/navigator";

export default function App() {
  return <Navigator />;
}
